import { Link } from "react-router-dom";
import { ClipboardList, Map, Wrench, ArrowRight, Tent } from "lucide-react";
import { PageHeader } from "@/components/shared/PageHeader";
import { InfoSection } from "@/components/home/InfoSection";
import { DocumentsSection } from "@/components/home/DocumentsSection";
import { Reveal, SectionHeader } from "@/components/shared/Reveal";

const IMG = "https://customer-assets-jai6qajn.emergentagent.net/job_novemberkasan-live/artifacts/0rfl2701_DSC07020.webp";

const SHORTCUTS = [
  { icon: Tent, label: "Boka depåplats", to: "/depa-bokning" },
  { icon: ClipboardList, label: "Startlistor", to: "/dokument" },
  { icon: Map, label: "Depåkarta", to: "/depa-bokning" },
  { icon: Wrench, label: "Teknisk kontroll", to: "/tavlingsinformation" },
];

export default function ForForare() {
  return (
    <>
      <PageHeader kicker="Deltagare" title="För Förare" subtitle="All viktig information för dig som kör Novemberkåsan 2026." image={IMG} />
      <section className="py-16">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <Reveal><SectionHeader kicker="Genvägar" title="Snabblänkar" /></Reveal>
          <div className="mt-8 grid grid-cols-2 lg:grid-cols-4 gap-4">
            {SHORTCUTS.map((s, i) => (
              <Reveal key={s.label} delay={i * 0.06}>
                <Link to={s.to} className="group flex flex-col gap-3 rounded-xl border border-white/8 bg-[#14161A] p-6 hover-lift hover:border-amber-500/50">
                  <s.icon className="w-8 h-8 text-amber-500" />
                  <span className="font-display text-xl font-bold uppercase text-white">{s.label}</span>
                  <span className="inline-flex items-center gap-1 text-xs font-mono uppercase tracking-widest text-white/40 group-hover:text-amber-500">Öppna <ArrowRight className="w-3 h-3" /></span>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <InfoSection heading="Förarinformation" kicker="Detaljer" />
      <DocumentsSection limit={6} />
    </>
  );
}
